import ApiError from 'utils/api/errors/ApiError';
import _ from 'lodash';

_.noConflict();

class ApiBadRequestError extends ApiError {
  constructor (props) {
    super(props);
    this.name = 'ApiBadRequestError';
    this.overridenErrors = null;
    this.overridenMessage = null;
    this.overridenTitle = null;
  }

  setValidationErrors (errors) {
    this.overridenErrors = errors;
  }

  setErrorMessage (msg) {
    this.overridenMessage = msg;
  }

  setTitleMessage (title) {
    this.overridenTitle = title;
  }

  getValidationErrors () {
    if (!_.isNil(this.overridenErrors)) {
      return this.overridenErrors;
    }
    if (this.originalError.response.data.errors) {
      return this.originalError.response.data.errors;
    }

    console.warn('No validation errors');
    return {};
  }

  getErrorMessage () {
    if (!_.isNil(this.overridenMessage)) {
      return this.overridenMessage;
    }
    if (this.originalError.response.data.errors &&
      this.originalError.response.data.errors.message) {
      return this.originalError.response.data.errors.message;
    }
    return '';
  }

  getErrorTitle () {
    if (!_.isNil(this.overridenTitle)) {
      return this.overridenTitle;
    }

    if (this.originalError.response.data.errors &&
      this.originalError.response.data.errors?.title) {
      return this.originalError.response.data.errors?.title;
    }
    return '';
  }
}

export default ApiBadRequestError;
